module.exports = __webpack_public_path__ + "img/Group12461@2x.80b781d8.png";